<script setup>
import {defineProps, ref, onMounted} from 'vue'

const props = defineProps({
  title: String,
});

</script>


<template>
<div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <h2 class="mb-3 jura">{{ props.title }}</h2>
      </div>
      <div class="col-md-12">
        <slot></slot>
      </div>
    </div>
  </div>
</div>
</template>
